import { Injectable } from '@angular/core';
import { UrlTree, CanActivate, Router } from '@angular/router';
import { AuthStoreService } from '@motivforce/mx-library-angular';
import { filter, Observable, of, switchMap } from 'rxjs';

import { User } from '../model/user';
import { isNonNull } from './redeem-blocked.guard';

@Injectable({
  providedIn: 'root',
})
export class AwaitingApprovalGuard implements CanActivate {
  constructor(private router: Router, private authStore: AuthStoreService) {}

  canActivate(): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.authStore.isRegularUser$.pipe(
      filter(isNonNull),
      switchMap((isRegularUser: boolean) => {
        if (isRegularUser) {
          if (this.isAwaitingApproval()) {
            this.router.navigateByUrl('/awaiting-approval');
            return of(false);
          }
        }
        return of(true);
      })
    );
  }

  private isAwaitingApproval() {
    return (this.authStore.userSettings?.user as User)?.statusId === 2;
  }
}
